import {
  Button,
  Checkbox,
  Drawer,
  Input,
  Label,
  Loading,
  Radio,
} from "@components";
import styles from "@styles/home-configurations.module.scss";
import { useEffect, useMemo, useState } from "react";
import { If } from "shared/components/control-statements";
import { Benefit } from "shared/core/Benefit";
import BrandUnits from "./BrandUnits";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { UserStorage } from "shared/tools/UserStorage";
import { MiniCheck, MiniInfo, SuccessIcon } from "shared/components/Icons";
import classNames from "classnames/bind";
import Availability from "./Availability";
import { Environment } from "shared/core/Environment";
const css = classNames.bind(styles);

const buildCoupon = (coupon) => {
  const rules = Benefit.getRules(coupon);

  coupon.rules = rules;

  if (Environment.id === 51) {
    coupon.description = !coupon.description ? `${coupon.code}` : coupon.description;
  } else coupon.description = !coupon.description
    ? `${coupon.code} ${coupon.pin ? `- ${coupon.pin}` : ""}`
    : coupon.description;

  return coupon;
};

const CouponsAdd = ({
  section,
  onClose,
  coupons = [],
  onFinish,
  onSave,
  item,
  items,
  onDeleteItem,
}) => {
  const [filteredCoupons, setFilteredCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(item || null);
  const [search, setSearch] = useState("");
  const [occurrences, setOcurrences] = useState();
  const [steps] = useState([
    { key: "ITEM", label: "Selecione o cupom", show: true },
    {
      key: "BRANDS_UNITS",
      label: "Marcas e unidades",
      show: true,
    },
    { key: "AVAILABILITY", label: "Configurar disponibilidade", show: true },
    { key: "OVERVIEW", label: "Resumo", show: true },
  ]);
  const [configItem, setConfigItem] = useState({
    target: {
      brands: item?.target?.brands || null,
      units: item?.target?.units || null,
      channels: item?.target?.channels || null,
    },
    availability: item?.availability || null,
  });
  const [selectedStep, setSelectedStep] = useState("ITEM");
  const [completedSteps, setCompletedSteps] = useState(["TYPE"]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [brands, setBrands] = useState([]);

  const couponsMap = useMemo(() => {
    return new Map((coupons || []).map((coupon) => [coupon.id, coupon]));
  }, [coupons]);

  useEffect(() => {
    setLoading(false);
  }, []);

  const handleConfig = (key, value) => {
    setConfigItem({ ...configItem, [key]: value });
  };

  const getVisibleSteps = () => steps.filter((step) => step.show);

  const handleContinue = () => {
    if (selectedStep === "OVERVIEW") {
      onSave({
        id: configItem.id || selectedItem?.id,
        target: configItem.target,
        availability: configItem.availability,
      });
      setShowSuccess(true);
      return;
    }

    setCompletedSteps((prev) =>
      prev.includes(selectedStep) ? prev : [...prev, selectedStep]
    );

    const visibleSteps = getVisibleSteps();
    const currentIndex = visibleSteps.findIndex(
      (step) => step.key === selectedStep
    );

    const nextStep = visibleSteps[currentIndex + 1];

    if (nextStep) setSelectedStep(nextStep.key);
  };

  const validateStep = () => {
    switch (selectedStep) {
      case "ITEM":
        return !!selectedItem?.id;
      case "BRANDS_UNITS":
        return true;
      case "AVAILABILITY":
        return (
          configItem.availability?.length > 0 ||
          configItem.availability === null
        );
      case "OVERVIEW":
        return true;
      default:
        return false;
    }
  };

  const isValidStep = validateStep();

  const weekDays = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

  const formatHour = (hour) => {
    const h = hour.padStart(4, "0").slice(0, 2);
    const m = hour.padStart(4, "0").slice(2);
    return `${h}:${m}`;
  };

  const Horaries = () => {
    if (configItem.availability === null) return <span>A todo momento</span>;

    return (
      <div>
        {configItem.availability.map((entry, index) => {
          const day = weekDays[entry.weekDay];
          const horaries = entry.times.map((t, idx) => (
            <span key={idx}>
              {formatHour(t.start)} - {formatHour(t.end)}
              {idx < entry.times.length - 1 && " / "}
            </span>
          ));

          return (
            <span key={index} className={styles.time}>
              <strong>{day}:</strong> {horaries}
              {index < configItem.availability.length - 1 && " | "}
            </span>
          );
        })}
      </div>
    );
  };

  const toggleSelectedItem = (item) => {
    if (selectedItem?.id === item.id) {
      setConfigItem({
        target: configItem.target,
        availability: configItem.availability,
      });
      setSelectedItem(null);
    } else {
      setConfigItem({ ...configItem, id: item.id, availability: null });
      setSelectedItem(item);
    }
  };

  useEffect(() => {
    if (search) {
      const lower_search = search.toLowerCase();
      const _coupons = coupons.filter(
        (a) => a.code?.toLowerCase().indexOf(lower_search) > -1
      );
      setFilteredCoupons(_coupons);
      setOcurrences(_coupons.length);
    } else {
      setFilteredCoupons(coupons);
      setOcurrences(coupons.length);
    }
  }, [search, coupons]);

  const builtSelectedItem = useMemo(() => {
    if (!selectedItem) return null;
    return couponsMap.get(selectedItem.id);
  }, [selectedItem, couponsMap]);

  const builtUnselectedItems = useMemo(() => {
    return filteredCoupons
      .map((item) => {
        if (!couponsMap.has(item.id)) return null;

        const isSelected =
          selectedItem?.id === item.id ||
          (items || []).some((i) => i.id === item.id);
        if (isSelected) return null;

        return buildCoupon(couponsMap.get(item.id));
      })
      .filter(Boolean);
  }, [filteredCoupons, selectedItem, couponsMap]);

  const loadBrandAndUnits = async () => {
    setLoading(true);
    let { environment_id, user_type } = UserStorage.getLoggedUser();

    if (user_type === "BRAND") {
      const holdingResponse = await EnvironmentsAPI.getById(environment_id);
      environment_id = holdingResponse.getData({}).environment_id;
    }

    const response = await EnvironmentsAPI.getUnits(String(environment_id));
    const brands = response.getData({}).brands;

    const brandsList = [];

    for (const b of brands) {
      const response = await EnvironmentsAPI.getUnits(String(b.id));
      const units = response.getData({})["units"];

      brandsList.push({
        id: b.id,
        name: b.name,
        units,
      });
    }
    setBrands(brandsList.flatMap((b) => b));
    setLoading(false);
  };

  useEffect(() => {
    loadBrandAndUnits();
  }, []);

  const mountChannelsAndBrands = () => {
    const channelsLabel = {
      1: "Delivery",
      2: "Retirar e levar",
      3: "Comer no local",
    };

    const targetChannels = (configItem.target.channels || []).map((c) => {
      return channelsLabel[c];
    });

    const targetBrands = (configItem.target.brands || []).map((b) => {
      const brand = brands.find((brand) => brand.id === b);
      if (brand) return `${brand.name} (${brand.units.length} unidades)`;
    });

    return `${targetChannels.join(", ")} / ${targetBrands.join(" / ")}`;
  };

  const totalCoupons = builtUnselectedItems.length;

  return (
    <>
      <div className={styles.homeHeader}>
        <div className="d-flex flex-column">
          <p className={styles.title}>Adicionar cupom</p>
          <p className={styles.subtitle}>{section.title}</p>
        </div>
        <div className="d-flex align-center">
          <If cond={selectedStep === "ITEM"}>
            <Input
              search
              value={search}
              records={occurrences}
              placeholder="Buscar por..."
              className="mb-0 pt-0"
              design="search"
              prefix
              prefixWidth={20}
              onChange={(t) => setSearch(t.target.value)}
            />
            <div className={styles.hairline} />
          </If>
          <div className={styles.close} onClick={onClose}>
            <i className="fas fa-times" />
          </div>
        </div>
      </div>

      <If cond={!showSuccess}>
        <div className={styles.homeSidebar}>
          <ul>
            {steps
              .filter(({ show }) => show)
              .map(({ key, label }) => {
                const isSelected = selectedStep === key;
                const isCompleted = completedSteps.includes(key);

                return (
                  <li
                    key={String(key)}
                    className={css({ selected: isSelected })}
                    onClick={() => {
                      if (key === "TYPE") return onClose();
                      if (isCompleted) setSelectedStep(key);
                    }}
                  >
                    {isCompleted ? <MiniCheck /> : <MiniInfo />}
                    <span>{label}</span>
                  </li>
                );
              })}
          </ul>
        </div>
      </If>

      <If cond={loading}>
        <div className={styles.scrollContainerNoPadding}>
          <div className={styles.sectionContent}>
            <div
              className="d-flex align-center justify-center"
              style={{ height: 300 }}
            >
              <Loading />
            </div>
          </div>
        </div>
      </If>

      <If cond={!showSuccess && !loading}>
        <div className={styles.scrollContainerNoPadding}>
          <div className={styles.sectionContent}>
            <If cond={selectedStep === "ITEM"}>
              <If cond={builtSelectedItem}>
                <div className={styles.selectedCouponsItems}>
                  <p className={styles.label}>Selecionado:</p>

                  <div
                    className={styles.coupon}
                    key={builtSelectedItem?.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleSelectedItem(builtSelectedItem);
                    }}
                  >
                    <div className="d-flex align-center justify-between w-100">
                      <div className="d-flex align-center">
                        <Radio
                          family="coupon"
                          value={true}
                          checked={true}
                          readOnly
                        />
                        <div className={styles.divisor} />
                        <div className="d-flex align-center">
                          <div className={styles.image}>
                            {builtSelectedItem?.image && (
                              <img
                                src={`${process.env.REACT_APP_ASSETS_URL}/${builtSelectedItem?.image}`}
                                alt=""
                              />
                            )}
                          </div>
                          <div className="d-flex flex-column">
                            <p className={styles.name}>
                              {selectedItem?.description ||
                                `${selectedItem?.code} ${
                                  selectedItem?.pin && Environment.id !== 51
                                    ? `- ${selectedItem?.pin}`
                                    : ""
                                }`}
                            </p>
                            <p className={styles.rules}>
                              {builtSelectedItem?.rules.map((rule, index) => (
                                <span className={styles.rule} key={index}>
                                  {rule}
                                </span>
                              ))}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </If>

              <If cond={builtUnselectedItems.length}>
                <div className={styles.unselectedCouponsItems}>
                  <p className={styles.label}>
                    Todos os cupons ({totalCoupons})
                  </p>
                  <div className={styles.couponsItems}>
                    {builtUnselectedItems.map((coupon) => {
                      return (
                        <div
                          className={styles.coupon}
                          key={coupon.id}
                          onClick={() => toggleSelectedItem(coupon)}
                        >
                          <div className="d-flex align-center">
                            <div className="d-flex align-center">
                              <Radio
                                family="coupon"
                                value={coupon.id}
                                checked={false}
                              />
                              <div className={styles.divisor} />
                              <div className="d-flex align-center">
                                <div className={styles.image}>
                                  {coupon.image && (
                                    <img
                                      src={`${process.env.REACT_APP_ASSETS_URL}/${coupon.image}`}
                                      alt=""
                                    />
                                  )}
                                </div>
                                <div className="d-flex flex-column">
                                  <p className={styles.name}>
                                    {coupon.description}
                                  </p>
                                  <p className={styles.rules}>
                                    {coupon.rules.map((rule, index) => (
                                      <span className={styles.rule} key={index}>
                                        {rule}
                                      </span>
                                    ))}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </If>
            </If>

            <If cond={selectedStep === "BRANDS_UNITS"}>
              <div className={styles.brandsAndUnits}>
                <div className={styles.selectedProduct}>
                  <If cond={selectedItem?.image}>
                    <div className={styles.image}>
                      <img
                        src={
                          process.env.REACT_APP_ASSETS_URL +
                          `/` +
                          selectedItem?.image
                        }
                        alt=""
                      />
                    </div>
                  </If>
                  <div className="d-flex flex-column">
                    <If cond={Environment.id === 51}>
                      <p>
                        {selectedItem?.description || `${selectedItem?.code}`}
                      </p>
                    </If>
                    <If cond={Environment.id !== 51}>
                      <p>
                        {selectedItem?.description ||
                          `${selectedItem?.code} - ${selectedItem?.pin}`}
                      </p>
                    </If>
                    <span>{(selectedItem?.rules || []).join(" / ")}</span>
                  </div>
                </div>

                <BrandUnits
                  data={configItem.target}
                  onChange={(data) => {
                    handleConfig("target", {
                      brands: data.brands || [],
                      units: data.units || [],
                      channels: data.channels || [],
                    });
                  }}
                />
              </div>
            </If>

            <If cond={selectedStep === "AVAILABILITY"}>
              <div className={styles.availabilityContainer}>
                <Availability
                  availability={configItem.availability}
                  onChange={(availability) =>
                    handleConfig("availability", availability)
                  }
                  item
                />
              </div>
            </If>

            <If cond={selectedStep === "OVERVIEW"}>
              <div className={styles.overviewContainer}>
                <div className={styles.configContainer}>
                  <p className={styles.title}>Resumo</p>

                  <ul className={styles.resume}>
                    <li>
                      <p>Selecione o cupom</p>
                      <If cond={Environment.id !== 51}>
                        <span>
                          {selectedItem?.description ||
                            `${selectedItem?.code} - ${selectedItem?.pin}`}
                        </span>
                      </If>
                      <If cond={Environment.id === 51}>
                        <span>
                          {selectedItem?.description || `${selectedItem?.code}`}
                        </span>
                      </If>
                    </li>
                    <li>
                      <p>Marcas e Unidades</p>
                      <span>{mountChannelsAndBrands()}</span>
                    </li>
                    <li>
                      <p>Disponibilidade</p>
                      <Horaries />
                    </li>
                  </ul>
                </div>
              </div>
            </If>

            <div className={styles.footer}>
              {item?.id && (
                <Button
                  design="danger"
                  className="mr-10"
                  onClick={() => onDeleteItem(item)}
                >
                  Remover cupom
                </Button>
              )}
              <Button
                design="primary"
                onClick={handleContinue}
                disabled={!isValidStep}
              >
                {selectedStep === "OVERVIEW"
                  ? "Confirmar e finalizar"
                  : "Próximo"}
              </Button>
            </div>
          </div>
        </div>
      </If>

      <If cond={showSuccess}>
        <div className={styles.successContainer}>
          <div className={styles.successIcon}>
            <SuccessIcon size={14} />
          </div>
          <p className={styles.successMessage}>
            <If cond={item}>Seção atualizada com sucesso.</If>
            <If cond={!item}>Cupom adicionado na seção com sucesso.</If>
          </p>

          <div className={styles.footer}>
            <Button design="primary" onClick={onFinish}>
              Fechar
            </Button>
          </div>
        </div>
      </If>
    </>
  );
};

export default CouponsAdd;
